import { useEffect, useState } from 'react';
export const useDropdownPosition = (inputRef) => {
    const [dropdownMaxHeight, setDropdownMaxHeight] = useState();
    const [dropdownWidth, setDropdownWidth] = useState();
    const [mobileAnchor, setMobileAnchor] = useState();
    const resize = () => {
        var _a, _b, _c;
        const newMaxHeight = Math.max(window.innerHeight - ((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().bottom) - 20, window.innerHeight * 0.25);
        setDropdownMaxHeight(newMaxHeight);
        setDropdownWidth((_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width);
        setMobileAnchor((_c = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().height);
    };
    if (inputRef.current && !dropdownMaxHeight) {
        resize();
    }
    useEffect(() => {
        window.addEventListener('resize', resize);
        return () => {
            window.removeEventListener('resize', resize);
        };
    }, []);
    return { dropdownMaxHeight, dropdownWidth, mobileAnchor, resize };
};
